import _objectWithoutProperties from "/codebuild/output/src2324380805/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["predicates"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { castArray } from "./lib/castArray.js";
var RENAMED_PARAMS = {
  accessToken: "access_token"
};
var castOrderingToString = function castOrderingToString(ordering) {
  return typeof ordering === "string" ? ordering : [ordering.field, ordering.direction === "desc" ? ordering.direction : void 0].filter(Boolean).join(" ");
};
var buildQueryURL = function buildQueryURL(endpoint, args) {
  var predicates = args.predicates,
    params = _objectWithoutProperties(args, _excluded);
  var url = new URL("documents/search", "".concat(endpoint, "/"));
  if (predicates) {
    var _iterator = _createForOfIteratorHelper(castArray(predicates)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var predicate = _step.value;
        url.searchParams.append("q", "[".concat(predicate, "]"));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  for (var k in params) {
    var _RENAMED_PARAMS$k;
    var name = (_RENAMED_PARAMS$k = RENAMED_PARAMS[k]) !== null && _RENAMED_PARAMS$k !== void 0 ? _RENAMED_PARAMS$k : k;
    var value = params[k];
    if (name === "orderings") {
      var scopedValue = params[name];
      if (scopedValue != null) {
        var v = castArray(scopedValue).map(function (ordering) {
          return castOrderingToString(ordering);
        }).join(",");
        value = "[".concat(v, "]");
      }
    } else if (name === "routes") {
      if (typeof params[name] === "object") {
        value = JSON.stringify(castArray(params[name]));
      }
    }
    if (value != null) {
      url.searchParams.set(name, castArray(value).join(","));
    }
  }
  return url.toString();
};
export { buildQueryURL };